import React, { useState } from 'react';
import logoamerisa from '../assets/logoamerisa.png';

const Topbar = ({ 
  showSearch = true, 
  title = '', 
  onSearchChange = () => {}, 
  searchValue = '',
  rightContent = null
}) => {
  const [notificationsOpen, setNotificationsOpen] = useState(false);

  const toggleNotifications = () => {
    setNotificationsOpen(!notificationsOpen);
  };
  
  return (
    <div className="bg-sky-900 text-white p-4 flex items-center justify-between relative">
      

      <div className="flex items-center">
        <img src={logoamerisa} alt="Logo" className="h-8" />
        {title && <h1 className="ml-4 text-xl font-semibold">{title}</h1>}
      </div>
      {/* Aviso de mantenimiento programado 
      <div
        className="flex items-center gap-2 px-4 py-1 rounded-md border border-yellow-300 bg-gradient-to-r from-yellow-100 to-yellow-300 text-yellow-900 shadow-md mx-4 animate-pulse"
        style={{ minWidth: 0 }}
      >
        <svg className="w-5 h-5 text-yellow-600 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        <span className="truncate text-sm font-medium">
          <b>Aviso:</b> El sistema estará en <b>mantenimiento programado</b> el <b>17 de agosto de 2025</b> a las <b>17:00 hrs</b>. Durante este periodo, es posible experimentar intermitencias o errores. Agradecemos su comprensión.
        </span>
      </div>*/}
      <div className="flex items-center">
       {/* {showSearch && (
          <div className="relative max-w-sm w-full mr-4">
            <input
              type="text"
              placeholder="Buscar..."
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              className="w-full p-2 pl-10 bg-white border rounded-md text-sm text-gray-700"
            />
            <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">
              🔍
            </span>
          </div>
        )}*/}
        
        <div className="flex items-center">
          <button 
            onClick={toggleNotifications} 
            className="p-2 rounded-full hover:bg-sky-800 relative focus:outline-none"
            aria-label="Notificaciones"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1" />
            </svg>
            <span className="absolute top-1 right-1 inline-block w-2 h-2 bg-red-500 rounded-full"></span>
          </button>
          
          {rightContent && rightContent}
        </div>
        
        {notificationsOpen && (
          <div className="absolute right-4 top-16 w-80 bg-white shadow-lg rounded-md z-10 text-gray-800">
            <div className="p-4 border-b">
              <h3 className="font-semibold">Notificaciones</h3>
            </div>
            <div className="max-h-80 overflow-y-auto">
              <div className="p-4 border-b hover:bg-gray-50">
                <div className="flex items-start">
                  <div className="bg-blue-100 p-2 rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <p className="text-sm font-medium">Nueva orden creada</p>
                    <p className="text-xs text-gray-500">Hace 5 minutos</p>
                  </div>
                </div>
              </div>
              <div className="p-4 border-b hover:bg-gray-50">
                <div className="flex items-start">
                  <div className="bg-green-100 p-2 rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <p className="text-sm font-medium">Orden #1234 completada</p>
                    <p className="text-xs text-gray-500">Hace 1 hora</p>
                  </div>
                </div>
              </div>
              <div className="p-4 hover:bg-gray-50">
                <div className="flex items-start">
                  <div className="bg-yellow-100 p-2 rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <p className="text-sm font-medium">Alerta de inventario</p>
                    <p className="text-xs text-gray-500">Ayer</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-2 text-center border-t">
              <button className="text-sm text-sky-600 hover:text-sky-800 font-medium">
                Ver todas las notificaciones
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Topbar;
